import { render } from "./PopoverBase.vue?vue&type=template&id=f751b8e6&scoped=true&ts=true"
import script from "./PopoverBase.vue?vue&type=script&lang=ts"
export * from "./PopoverBase.vue?vue&type=script&lang=ts"

import "./PopoverBase.vue?vue&type=style&index=0&id=f751b8e6&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f751b8e6"]])

export default __exports__